// extracted by mini-css-extract-plugin
export var image = "styles-module--image--f7853";
export var suptitle = "styles-module--suptitle--7a231";